import { type GridApi } from 'ag-grid-community';
import { useEffect } from 'react';

export function useScrollOnSearchDone(isSearching: boolean, gridApi?: GridApi | null) {
  useEffect(() => {
    if (isSearching) {
      return;
    }
    queueMicrotask(() => gridApi?.ensureIndexVisible(0));
  }, [isSearching, gridApi]);
}
